// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./WarningModalStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Modal } from "../../index";
export const WarningModal = (props) => {
    const classes = useStyles(props);
    const modalWidth = 285;
    const modalHeight = 150;
    const { isModalOpen, data, onClickRedButton, onClickGreenButton, modalType } = props;
    return (React.createElement(Modal, { isModalOpen: isModalOpen, width: modalWidth, height: modalHeight },
        React.createElement("div", { className: classes.floatingDiv },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { container: true, item: true, md: 12, className: classes.floatingDivContent, alignItems: "center", justifyContent: "center", style: { height: modalHeight - 50 } }, data.message),
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarBottom },
                    React.createElement(Grid, { container: true },
                        modalType === "singleOption" && (React.createElement(Grid, { item: true, md: 12 },
                            React.createElement(Button, { className: classes.redButton, onClick: onClickRedButton }, "Ok"))),
                        modalType === "doubleOption" && (React.createElement(React.Fragment, null,
                            React.createElement(Grid, { item: true, md: 6 },
                                React.createElement(Button, { className: classes.redButton, onClick: onClickRedButton }, "Yes")),
                            React.createElement(Grid, { item: true, md: 6 },
                                React.createElement(Button, { className: classes.greenButton, onClick: onClickGreenButton }, "No"))))))))));
};
WarningModal.defaultProps = {
    setOpenModalState: () => { },
    onClickRedButton: () => { },
    onClickGreenButton: () => { }
};
export default React.memo(WarningModal);
